import { ContextMenuOption } from '../../../../components/ui/contextMenu/dtos/ContextMenuOption.dto'

export abstract class FireOutbreakReaction implements ContextMenuOption {
	constructor(
		readonly name: string,
		readonly icon: string,
		readonly event: string,
	) {}
}
